import {
  TRASH_CLEANUP_INTERVAL_MS,
  TRASH_CLEANUP_LAST_RUN_KEY,
} from './constants';

/**
 * Phase 1 throttle for the login-driven trash cleanup: keep the last-run
 * timestamp in localStorage and only allow a new run once the interval has
 * elapsed. A later phase will layer an org SDO on top (check localStorage
 * first, then the SDO) so the throttle is shared across a user's devices.
 *
 * All access is defensive — if localStorage is unavailable we treat cleanup as
 * due rather than blocking it.
 */
export const isTrashCleanupDue = (now: number = Date.now()): boolean => {
  try {
    const last = window.localStorage.getItem(TRASH_CLEANUP_LAST_RUN_KEY);
    if (!last) {
      return true;
    }
    const lastMs = Number(last);
    if (!Number.isFinite(lastMs)) {
      return true;
    }
    return now - lastMs >= TRASH_CLEANUP_INTERVAL_MS;
  } catch {
    return true;
  }
};

export const markTrashCleanupRan = (now: number = Date.now()): void => {
  try {
    window.localStorage.setItem(TRASH_CLEANUP_LAST_RUN_KEY, String(now));
  } catch {
    // Ignore storage errors (private mode, quota, etc.).
  }
};
